var React = require('react');

function IcAwsElasticBlockStoreVolume (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M35.191,10.374H4.868c-0.47,0-0.851,0.381-0.851,0.851v27.923c0,0.47,0.381,0.851,0.851,0.851h30.323\n\tc0.47,0,0.851-0.381,0.851-0.851V11.225C36.042,10.755,35.662,10.374,35.191,10.374z M34.34,38.298H5.719V12.077H34.34V38.298z\n\t M4.808,8.885h30.374c0.322,0,0.618-0.182,0.761-0.471s0.113-0.634-0.081-0.891L30.468,0.34C30.307,0.126,30.055,0,29.787,0H10.213\n\tc-0.268,0-0.519,0.125-0.68,0.34L4.128,7.522C3.934,7.78,3.903,8.125,4.047,8.414C4.191,8.703,4.486,8.885,4.808,8.885z\n\t M10.637,1.702h18.724l4.117,5.481H6.514L10.637,1.702z"}));
}

IcAwsElasticBlockStoreVolume.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsElasticBlockStoreVolume;

IcAwsElasticBlockStoreVolume.default = IcAwsElasticBlockStoreVolume;
